import React, { useMemo, useState } from "react";

import { IUserInfo } from "api/model/user/IUserInfo";
import { IUserSessionData } from "api/model/user/IUserSessionData";
import { useDisplayTimezone } from "hooks/useTimezone";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { queryClient } from "services/HttpService";
import { T } from "services/lang/LanguageService";
import { exportUserSessions } from "../stats-utils";

const ExportDialogContent: React.FC<{ users: IUserSessionData[] }> = ({ users }) => {
  const [selectedUsers, setSelectedUsers] = useState<string[]>(() =>
    Array.from(new Set(users.map(u => u.username)))
  );
  const displayTz = useDisplayTimezone();

  const userOptions = useMemo(() => {
    if (!users) return [];
    const uniqueUsers = new Set(users.map(u => u.username));
    const userInfos = Array.from(uniqueUsers).map(username => {
      const userInfo = queryClient.getQueryCache().find({ queryKey: ["user-info", username] })?.state.data as
        | IUserInfo
        | undefined;

      return { label: userInfo?.displayName ?? username, value: username };
    });
    return userInfos;
  }, [users]);

  const handleExport = () => {
    const filteredUsers = users.filter(user => selectedUsers.includes(user.username));
    exportUserSessions(filteredUsers, userOptions, displayTz);
  };

  return (
    <>
      <div className="flex flex-column gap-2">
        <label>{T("word.users")}</label>
        <MultiSelect
          value={selectedUsers}
          options={userOptions}
          filter
          onChange={e => setSelectedUsers(e.value)}
          className="w-20rem"
          maxSelectedLabels={1}
          selectedItemsLabel="{0} users selected"
        />
      </div>
      <div className="flex flex-column gap-2 mt-3">
        <label>{T("action.export")}</label>
        <Button
          type="button"
          icon="pi pi-file-excel text-xl text-primary-800"
          className="w-full h-full"
          severity="info"
          outlined
          onClick={handleExport}
        />
      </div>
    </>
  );
};

export default ExportDialogContent;
